import { getScormPackageClient, type ScormEdition } from "../../client/svcScorm";
import { getCurrentSelectedTenant, getTenantUuid } from "../../utils";

export type ScormLesson = {
  lessonKey: string;
  name: string;
  description: string;
};

export const generateScormPackage = async ({
  lessons = [],
  edition,
}: {
  lessons: ScormLesson[];
  edition?: ScormEdition;
}) => {
  if (!lessons?.length) {
    throw new Error("No lessons provided");
  }

  const tenantUuid = await getTenantUuid();
  if (!tenantUuid) {
    throw new Error("Tenant UUID not found");
  }

  const tenant = getCurrentSelectedTenant();
  if (!tenant) {
    throw new Error("No tenant selected");
  }

  const scormClient = getScormPackageClient();

  const payload = {
    idpUuid: tenantUuid,
    tenant,
    edition,
    courses: lessons.map(({ name, lessonKey, description }) => ({
      title: name,
      lessonKey,
      description,
    })),
  };

  const result = await scormClient.generateScormPackage(payload);
  if (result.error) {
    throw result.error;
  }
};
